import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const INSTAGRAM_URL = "https://www.instagram.com/wonderparcel?igsh=MTM0YWJ0YnBjY3U0bQ==";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings(null));
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);

export function useInstagram() {
  const s = useSettings();
  return {
    url: s?.instagram?.url || INSTAGRAM_URL,
    handle: s?.instagram?.handle || "@wonderparcel",
    enabled: s?.instagram?.enabled !== false,
    tiles: s?.instagram?.tiles || [],
  };
}

export function useFeature(flag) {
  const s = useSettings();
  // default to enabled for core flags until settings load
  if (!s) return true;
  return s.feature_flags?.[flag] !== false;
}
